export default __webpack_public_path__ + "static/media/signUp.80011238.png";